// User-facing Watchlist version labels.
//
// The backend's `display_version` is the only number users see: the position
// of a published version among the user's versions. Pending, failed and
// unpublished changes have none. `revision_seq` is an internal key used for
// fences and receipts, and it is never shown.

export function watchlistDisplayVersion(source) {
    const raw = source?.display_version;
    if (raw === null || raw === undefined || raw === '' || typeof raw === 'boolean') {
        return null;
    }
    const value = Number(raw);
    return Number.isSafeInteger(value) && value > 0 ? value : null;
}

export function watchlistVersionLabel(source) {
    const version = watchlistDisplayVersion(source);
    return version ? `Version ${version}` : '';
}

export function watchlistVersionSuffix(source) {
    const label = watchlistVersionLabel(source);
    return label ? ` (${label})` : '';
}

export function formatWatchlistUpdateTime(value) {
    if (!value) return '';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '';
    return parsed.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
}
